import * as React from "react";

import { ApiClient } from "../../../services/ApiClient";
import { IControlSchema } from "../../Controls";
import { breakLine, Component, I18NString, isNullOrEmpty } from "../../Utils";
import { Strings } from "../../../messages";
import {getRandomKey} from '../../Utils'
import { IDispatcher } from '../extensions/Dispatcher'

interface IServiceTableColumn {
    title: I18NString;
}

export interface IServiceTableSchema extends IControlSchema {
    columns: IServiceTableColumn[];
    value: any[];
}

export interface IServiceTableProps {
    schema: IServiceTableSchema;
    api: ApiClient;
}

interface IServiceTableState {
    current?: number;
}

class ServiceTable extends Component<IServiceTableProps, IServiceTableState> {

    constructor() {
        super();

        this.state = {
            current: null
        };
    }

    componentDidMount() {
        if (!isNullOrEmpty(this.props.schema.value)) {
            this.props.schema.value.sort((l, r) => {
                return r.timestamp - l.timestamp;
            });
        }
    }

    public render() {
        if(isNullOrEmpty(this.props.schema.value)) {
            return (
                <div className="alert alert-info">{this.tr(Strings["EMPTY"])}</div>
            )
        }

        const rows = [];
        for(const value of this.props.schema.value) {
            const row = [];
            for (const i in value.value) {
                if(value.value.hasOwnProperty(i)) {
                    let column = value.value[i];
                    if (typeof column == "string") {
                        column = breakLine(column)
                    } else if(typeof column == "object") {
                        const url = this.props.api.getFileUrl(this.props.schema.id, column.fileName, value.timestamp);
                        column = <a target="_blank" href={url}>{column.fileName}</a>;
                    }
                    row.push(<td key={getRandomKey()}>{column}</td>);
                }
            }

            rows.push(<tr key={getRandomKey()}>{row}</tr>)
        }

        const headers = this.props.schema.columns
                            .map((column, idx)=> 
                                    (<th key={idx}>{this.tr(column.title)}</th>))
       

        return (
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>{headers}</tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        )
    }

}

export function createServiceTable(schema: IControlSchema, api: ApiClient, dispatcher:IDispatcher=null): React.ReactElement<any> {
    return <ServiceTable schema={schema as IServiceTableSchema} api={api} />;
}


// WEBPACK FOOTER //
// ./src/components/controls/service/ServiceTable.tsx